import { useEffect } from "react"
import { useReportLandingContext } from "."
import { cloneDeep } from "lodash"
import { useOverviewDashboardContext } from "@/components/analysisModules/OverviewDashboard/OverviewDashboardContext"

export const useUpdateLoadedWidgetsTracker = ({status, widgetIdx, hasData, widgetId}) => {

  const reportContext = useReportLandingContext();
  const overviewContext = useOverviewDashboardContext();

  const {setLoadedWidgetsTracker} = reportContext || overviewContext || {}
  const { reportWidgetDataStatus, trackerResetKey } = overviewContext || {};

  useEffect(() => {
    if(status === 'success' || status === 'error'){
      setLoadedWidgetsTracker && setLoadedWidgetsTracker(prev => {

        const newState = cloneDeep(prev);

        /**
         * this scenario is specifically possible in
         * edit more, when people are editing, deleting,
         * rearranging widgets.
         */
        const alreadyExistsInStateIdx = newState.findIndex(s => s.index === widgetIdx);
        if(alreadyExistsInStateIdx !== -1){
          //we still update it in case the status changed.
          newState[alreadyExistsInStateIdx] = {index: widgetIdx, status}
          return newState;
        }
        //else
        return [
        ...newState,
        {
          index: widgetIdx,
          status
        }
      ]})

      if (status === 'success' && reportWidgetDataStatus && widgetId !== undefined && hasData !== undefined) {
        reportWidgetDataStatus(widgetId, hasData);
      }
    }
  },[status, widgetIdx, hasData, widgetId, reportWidgetDataStatus, trackerResetKey])

}